import IShift from '@/models/Shifts/IShift';
import DateTimeUtils from '@/lib/dateTimeUtils';

export default (value: IShift) => {
    const start = new Date(value.startAt).toLocaleTimeString(['en-GB'], {hour: '2-digit', minute: '2-digit'});
    const end = new Date(value.endAt).toLocaleTimeString(['en-GB'], {hour: '2-digit', minute: '2-digit'});
    return DateTimeUtils.calculateShiftLength(start, end);
} 